"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
class Subscription extends base_1.default {
    constructor(data = {
        id: undefined,
        unit_amount: undefined,
        currency: undefined,
        product_data: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.unit_amount = (0, defaults_1.defaultNumber)(data.unit_amount);
        this.currency = (0, defaults_1.defaultString)(data.currency);
        this.product_data = (0, defaults_1.defaultObject)(data);
    }
}
exports.default = Subscription;
